import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import React, { lazy } from 'react';
import { NCNotification } from '../../types/nc';
import { isValidNotification } from './validator';

const ErrorNotification = lazy(() =>
  retry(
    () => import(/* webpackChunkName: "ncmsgs" */ './Types/ErrorNotification')
  )
);
const WatchNotification = lazy(() =>
  retry(
    () => import(/* webpackChunkName: "ncmsgs" */ './Types/WatchNotification')
  )
);
const FaveNotification = lazy(() =>
  retry(
    () => import(/* webpackChunkName: "ncmsgs" */ './Types/FaveNotification')
  )
);
const CollectNotification = lazy(() =>
  retry(
    () => import(/* webpackChunkName: "ncmsgs" */ './Types/CollectNotification')
  )
);
const PrivateCollectNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/PrivateCollectNotification'
      )
  )
);
const CommentBadgeAwardNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/CommentBadgeAwardNotification'
      )
  )
);
const DeviationBadgeAwardNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/DeviationBadgeAwardNotification'
      )
  )
);
const BadgeNotification = lazy(() =>
  retry(
    () => import(/* webpackChunkName: "ncmsgs" */ './Types/BadgeNotification')
  )
);
const BadgeLevelledNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/BadgeLevelledNotification'
      )
  )
);
const DdToAuthorNotification = lazy(() =>
  retry(
    () =>
      import(/* webpackChunkName: "ncmsgs" */ './Types/DdToAuthorNotification')
  )
);
const DdToSuggesterNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/DdToSuggesterNotification'
      )
  )
);
const CommentMentionsDeviation = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/CommentMentionsDeviation'
      )
  )
);
const CommentMentionsUser = lazy(() =>
  retry(
    () => import(/* webpackChunkName: "ncmsgs" */ './Types/CommentMentionsUser')
  )
);
const DeviationMentionsDeviation = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/DeviationMentionsDeviation'
      )
  )
);
const DeviationMentionsUser = lazy(() =>
  retry(
    () =>
      import(/* webpackChunkName: "ncmsgs" */ './Types/DeviationMentionsUser')
  )
);
const ArtTheftReportNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/ArtTheftReportNotification'
      )
  )
);
const PointsTransactionNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/PointsTransactionNotification'
      )
  )
);
const CommentNotification = lazy(() =>
  retry(
    () => import(/* webpackChunkName: "ncmsgs" */ './Types/CommentNotification')
  )
);
const DownloadSoldNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/DownloadSoldNotification'
      )
  )
);
const RadomRecommendationNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/RadomRecommendationNotification'
      )
  )
);
const GroupCreatedNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/GroupCreatedNotification'
      )
  )
);
const GroupJoinedNotification = lazy(() =>
  retry(
    () =>
      import(/* webpackChunkName: "ncmsgs" */ './Types/GroupJoinedNotification')
  )
);
const GroupChangedRoleNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/GroupChangedRoleNotification'
      )
  )
);
const GroupLeftNotification = lazy(() =>
  retry(
    () =>
      import(/* webpackChunkName: "ncmsgs" */ './Types/GroupLeftNotification')
  )
);
const GroupRemovedDeviationNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/GroupRemovedDeviationNotification'
      )
  )
);
const GroupNoteNotification = lazy(() =>
  retry(
    () =>
      import(/* webpackChunkName: "ncmsgs" */ './Types/GroupNoteNotification')
  )
);
const CommissionRequestNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/CommissionRequestNotification'
      )
  )
);
const OriginalsOrderNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/OriginalsOrderNotification'
      )
  )
);
const BlogSubmissionAuthorNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/BlogSubmissionAuthorNotification'
      )
  )
);
const BlogSubmissionGroupNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/BlogSubmissionGroupNotification'
      )
  )
);
const GroupDeviationSubmissionRequestNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/GroupDeviationSubmissionRequestNotification'
      )
  )
);
const GroupDeviationSubmissionRequestReceiptNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/GroupDeviationSubmissionRequestReceiptNotification'
      )
  )
);
const ModelTagRequestNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/ModelTagRequestNotification'
      )
  )
);
const ModelTagRequestReceiptNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/ModelTagRequestReceiptNotification'
      )
  )
);
const GalleryBoughtNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/GalleryBoughtNotification'
      )
  )
);
const GallerySoldNotification = lazy(() =>
  retry(
    () =>
      import(/* webpackChunkName: "ncmsgs" */ './Types/GallerySoldNotification')
  )
);
const CommissionReceiptNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/CommissionReceiptNotification'
      )
  )
);

const ModerationReportRequestNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/ModerationReportRequestNotification'
      )
  )
);
const ModerationReportNeedInfoNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/ModerationReportNeedInfoNotification'
      )
  )
);
const CoreGiftedNotification = lazy(() =>
  retry(
    () =>
      import(/* webpackChunkName: "ncmsgs" */ './Types/CoreGiftedNotification')
  )
);
const RepliedNotification = lazy(() =>
  retry(
    () => import(/* webpackChunkName: "ncmsgs" */ './Types/RepliedNotification')
  )
);
const GroupInvitationNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/GroupInvitationNotification'
      )
  )
);
const GroupInvitationPermissionNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/GroupInvitationPermissionNotification'
      )
  )
);
const GroupInvitationReceiptNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/GroupInvitationReceiptNotification'
      )
  )
);
const GroupJoinRequestReceiptNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/GroupJoinRequestReceiptNotification'
      )
  )
);
const GroupJoinRequestNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/GroupJoinRequestNotification'
      )
  )
);
const CommentLikedNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/CommentLikedNotification'
      )
  )
);
const DeviationSubmissionOfferGroupNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/DeviationSubmissionOfferGroupNotification'
      )
  )
);
const DeviationSubmissionOfferArtistReceiptNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/DeviationSubmissionOfferArtistReceiptNotification'
      )
  )
);
const MsCancelledNotification = lazy(() =>
  retry(
    () =>
      import(/* webpackChunkName: "ncmsgs" */ './Types/MsCancelledNotification')
  )
);
const MsBillingFailedNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/MsBillingFailedNotification'
      )
  )
);
const MsCreatedToSubscriberNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/MsCreatedToSubscriberNotification'
      )
  )
);
const MsPromotionDywNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/MsPromotionDywNotification'
      )
  )
);
const MsUnsubscribedNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/MsUnsubscribedNotification'
      )
  )
);
const MsSubscribedToOwnerNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/MsSubscribedToOwnerNotification'
      )
  )
);
const MsUnsubscribedToOwnerNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/MsUnsubscribedToOwnerNotification'
      )
  )
);

const AdoptablesOfferNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/AdoptablesOfferNotification'
      )
  )
);

const AdoptablesOfferReceiptNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/AdoptablesOfferReceiptNotification'
      )
  )
);

const AdoptableSoldNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/AdoptableSoldNotification'
      )
  )
);

const AdoptableResoldNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/AdoptableResoldNotification'
      )
  )
);

const AdoptableBoughtNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/AdoptableBoughtNotification'
      )
  )
);

const AdoptableOfferAlertNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/AdoptableOfferAlertNotification'
      )
  )
);

const AdoptableOfferEndedNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/AdoptableOfferEndedNotification'
      )
  )
);

const AdoptablesGiftNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/AdoptablesGiftNotification'
      )
  )
);

const AdoptablesGiftReceiptNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/AdoptablesGiftReceiptNotification'
      )
  )
);

const AsamRecommendationNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/AsamRecommendationNotification'
      )
  )
);

const TopSupporterAchievementNotification = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ncmsgs" */ './Types/TopSupporterAchievementNotification'
      )
  )
);

export function renderNotification(notification: NCNotification) {
  if (!isValidNotification(notification)) {
    return <ErrorNotification notification={notification} />;
  }
  switch (notification.type) {
    case 'nc.new_watcher':
      return <WatchNotification notification={notification} />;
    case 'nc.fave':
      return <FaveNotification notification={notification} />;
    case 'nc.collect':
      return <CollectNotification notification={notification} />;
    case 'nc.private_collect':
      return <PrivateCollectNotification notification={notification} />;
    case 'nc.award_badge_given_on_comment':
      return <CommentBadgeAwardNotification notification={notification} />;
    case 'nc.award_badge_given_on_deviation':
      return <DeviationBadgeAwardNotification notification={notification} />;
    case 'nc.badge_given':
      return <BadgeNotification notification={notification} />;
    case 'nc.badge_levelled':
      return <BadgeLevelledNotification notification={notification} />;
    case 'nc.dd_to_author':
      return <DdToAuthorNotification notification={notification} />;
    case 'nc.dd_to_suggester':
      return <DdToSuggesterNotification notification={notification} />;
    case 'nc.comment_mentions_deviation':
      return <CommentMentionsDeviation notification={notification} />;
    case 'nc.comment_mentions_user':
      return <CommentMentionsUser notification={notification} />;
    case 'nc.deviation_mentions_deviation':
      return <DeviationMentionsDeviation notification={notification} />;
    case 'nc.deviation_mentions_user':
      return <DeviationMentionsUser notification={notification} />;
    case 'nc.points_transaction':
      return <PointsTransactionNotification notification={notification} />;
    case 'nc.comment':
      return <CommentNotification notification={notification} />;
    case 'nc.pcp_sold':
      return <DownloadSoldNotification notification={notification} />;
    case 'nc.art_theft_report':
      return <ArtTheftReportNotification notification={notification} />;
    case 'nc.adoptable_offer':
      return <AdoptablesOfferNotification notification={notification} />;
    case 'nc.adoptable_offer_receipt':
      return <AdoptablesOfferReceiptNotification notification={notification} />;
    case 'nc.adoptable_sold':
      return <AdoptableSoldNotification notification={notification} />;
    case 'nc.adoptable_resold':
      return <AdoptableResoldNotification notification={notification} />;
    case 'nc.adoptable_bought':
      return <AdoptableBoughtNotification notification={notification} />;
    case 'nc.adoptable_offer_alert':
      return <AdoptableOfferAlertNotification notification={notification} />;
    case 'nc.adoptable_offer_ended':
      return <AdoptableOfferEndedNotification notification={notification} />;
    case 'nc.adoptable_gift':
      return <AdoptablesGiftNotification notification={notification} />;
    case 'nc.adoptable_gift_receipt':
      return <AdoptablesGiftReceiptNotification notification={notification} />;
    case 'nc.radom_recommendation':
      return <RadomRecommendationNotification notification={notification} />;
    case 'nc.group_created':
      return <GroupCreatedNotification notification={notification} />;
    case 'nc.group_joined':
      return <GroupJoinedNotification notification={notification} />;
    case 'nc.group_changed_role':
      return <GroupChangedRoleNotification notification={notification} />;
    case 'nc.group_left':
      return <GroupLeftNotification notification={notification} />;
    case 'nc.group_removed_deviation':
      return <GroupRemovedDeviationNotification notification={notification} />;
    case 'nc.group_note':
      return <GroupNoteNotification notification={notification} />;
    case 'nc.commission_request':
      return <CommissionRequestNotification notification={notification} />;
    case 'nc.originals_order':
      return <OriginalsOrderNotification notification={notification} />;
    case 'nc.deviation_submission_permission_group_receipt':
      return (
        <GroupDeviationSubmissionRequestReceiptNotification
          notification={notification}
        />
      );
    case 'nc.deviation_submission_permission_request':
      return (
        <GroupDeviationSubmissionRequestNotification
          notification={notification}
        />
      );
    case 'nc.blog_submission_author_receipt':
      return <BlogSubmissionAuthorNotification notification={notification} />;
    case 'nc.blog_submission_group_notification':
      return <BlogSubmissionGroupNotification notification={notification} />;
    case 'nc.model_tag_request':
      return <ModelTagRequestNotification notification={notification} />;
    case 'nc.model_tag_request_receipt':
      return <ModelTagRequestReceiptNotification notification={notification} />;
    case 'nc.gallery_bought':
      return <GalleryBoughtNotification notification={notification} />;
    case 'nc.gallery_sold':
      return <GallerySoldNotification notification={notification} />;
    case 'nc.commission_receipt':
      return <CommissionReceiptNotification notification={notification} />;
    case 'nc.moderation_report_request':
      return (
        <ModerationReportRequestNotification notification={notification} />
      );
    case 'nc.core_gifted':
      return <CoreGiftedNotification notification={notification} />;
    case 'nc.moderation_report_need_info':
      return (
        <ModerationReportNeedInfoNotification notification={notification} />
      );
    case 'nc.replied':
      return <RepliedNotification notification={notification} />;
    case 'nc.group_invitation':
      return <GroupInvitationNotification notification={notification} />;
    case 'nc.group_invitation_permission':
      return (
        <GroupInvitationPermissionNotification notification={notification} />
      );
    case 'nc.group_invitation_receipt':
      return <GroupInvitationReceiptNotification notification={notification} />;
    case 'nc.group_join_request':
      return <GroupJoinRequestNotification notification={notification} />;
    case 'nc.group_join_request_receipt':
      return (
        <GroupJoinRequestReceiptNotification notification={notification} />
      );
    case 'nc.comment_liked':
      return <CommentLikedNotification notification={notification} />;
    case 'nc.deviation_submission_offer_group_notification':
      return (
        <DeviationSubmissionOfferGroupNotification
          notification={notification}
        />
      );
    case 'nc.deviation_submission_offer_artist_receipt':
      return (
        <DeviationSubmissionOfferArtistReceiptNotification
          notification={notification}
        />
      );
    case 'nc.ms.cancelled':
      return <MsCancelledNotification notification={notification} />;
    case 'nc.ms.billing_fail':
      return <MsBillingFailedNotification notification={notification} />;
    case 'nc.ms.created_to_subscriber':
      return <MsCreatedToSubscriberNotification notification={notification} />;
    case 'nc.ms.promotion_dyw':
      return <MsPromotionDywNotification notification={notification} />;
    case 'nc.ms.unsubscribed':
      return <MsUnsubscribedNotification notification={notification} />;
    case 'nc.ms.subscribed_to_owner':
      return <MsSubscribedToOwnerNotification notification={notification} />;
    case 'nc.ms.unsubscribed_to_owner':
      return <MsUnsubscribedToOwnerNotification notification={notification} />;
    case 'nc.asam_recommendation':
      return <AsamRecommendationNotification notification={notification} />;
    case 'nc.achievement_top_supporter':
      return (
        <TopSupporterAchievementNotification notification={notification} />
      );
    default:
      return <ErrorNotification notification={notification} />;
  }
}
